import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

import { BREAKPOINT_MD, isAboveBreakpoint } from 'my-phorest/utils/breakpoints';

export default class SidebarService extends Service {
  @tracked isOpen = isAboveBreakpoint(BREAKPOINT_MD);

  @action
  toggleSidebar() {
    this.isOpen = !this.isOpen;
  }
}
